import { RESTUtils } from '@galigeo-store/ui-lib';
import { PortalAppContext } from '../state/portal-appcontext';

export interface SyncSchemaResponse {
  info: string;
  success: boolean;
  result?: any;
  error?: string;
  refreshPage?: boolean;
}

export class DeployService {
  public static async syncSchema(): Promise<SyncSchemaResponse> {
    return await RESTUtils.getJson(
      PortalAppContext.getBackendUrl() + '/feature/deploy/syncSchema',
      { handleError: false }, // Do not throw an error if the request fails,
    );
  }
}
